import * as React from 'react';
import { FormControl, Form, Panel, FormGroup, Col, ControlLabel, Button } from 'react-bootstrap';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { inject } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import { UiStore } from '../../stores/UiStore';
import { bind } from '../../utils/decorators';
import * as ApiTypes from '../../models/ApiTypes';
import LadeFortschritt from '../site/LadeFortschritt';

interface IAuftragDetailsAendernProps {
  auftrag: ApiTypes.IAuftrag;
  onAuftragNeuladen: () => void;
}

/** Komponente zum nachträglichen Ändern der Kopfdaten eines Auftrags */
@observer
export default class AuftragDetailsAendern extends React.Component<IAuftragDetailsAendernProps> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  @observable datenGeladen: boolean = false;

  // Kopfdaten
  @observable auftragname: string = '';
  @observable lizenznehmer: string = '';
  @observable verantwortlicher: string = '';
  @observable referenzdatum: string = '';
  @observable bemerkung = '';

  // Spezifische Eigenschaften (je nach Auftragstyp) werden als Meta-Daten verwaltet
  @observable meta: ApiTypes.IAuftragMeta[] = [
    { bezeichnung: ApiTypes.SES_TYP, inhalt: 'PKW' },
    { bezeichnung: ApiTypes.SES_BAHN, inhalt: '' }
  ];

  constructor(props: IAuftragDetailsAendernProps) {
    super(props);
    this.auftragname = this.props.auftrag.auftrag_name;
    this.lizenznehmer = this.props.auftrag.lizenznehmer;
    this.verantwortlicher = this.props.auftrag.verantwortlicher;
    this.bemerkung = this.props.auftrag.bemerkung ? this.props.auftrag.bemerkung : '';
    // Für die Übernahme in den Datepicker muss das Datum vom Deutschen Format (des Backends) in das ISO-Format konvertiert werden
    var datumTeile = this.props.auftrag.referenzdatum.split('.');
    this.referenzdatum = `${datumTeile[2]}-${datumTeile[1]}-${datumTeile[0]}`;
    // SES Aufträge speichern spezifische Eigenschaften als Metaden, die aus der entspr. Tabelle wiederhergestellt werden
    if (this.props.auftrag.kategorie.toLocaleLowerCase() === 'ses') {
      this.ladeMetaDatum(ApiTypes.SES_TYP);
      this.ladeMetaDatum(ApiTypes.SES_BAHN);
    }
  }

  @bind @action setDatenGeladen(value: boolean) {
    this.datenGeladen = value;
  }

  @bind ladeMetaDatum(bezeichnung: string) {
    let metaDatum = this.meta.find((meta) => meta.bezeichnung === bezeichnung);
    let metaDatumAuftrag = this.props.auftrag.meta.find(meta => meta.bezeichnung === bezeichnung);
    if (metaDatum && metaDatumAuftrag) {
      metaDatum.inhalt = metaDatumAuftrag.inhalt;
      console.table(metaDatum);
    }
  }

  @bind holeMetadatum(bezeichnung: string) {
    let metadatum = this.meta.find((meta) => meta.bezeichnung === bezeichnung);
    if (metadatum) {
      return metadatum.inhalt;
    }
    return '';
  }

  @bind @action setzeMetadatum(bezeichnung: string, inhalt: string) {
    let metadatum = this.meta.find((meta) => meta.bezeichnung === bezeichnung);
    if (metadatum) {
      metadatum.inhalt = inhalt;
    }
  }

  @bind @action handleSesFzKategorieSelected(event: React.FormEvent<FormControl>) {
    this.setzeMetadatum(ApiTypes.SES_TYP, (event.target as HTMLInputElement).value);
  }

  @bind @action handleSesBahnChanged(event: React.FormEvent<FormControl>) {
    this.setzeMetadatum(ApiTypes.SES_BAHN, (event.target as HTMLInputElement).value);
  }

  async componentDidMount() {
    this.setDatenGeladen(false);
    await this.uiStore.loadUserProfile();
    const userProfile = this.uiStore.userProfile;
    if (userProfile && userProfile.projektleiter) {
      await this.uiStore.loadPersonallisteKategorie(this.props.auftrag.kategorie);
    }
    await this.uiStore.loadFreigaben();
    if (this.uiStore.freigaben) {
      if (this.uiStore.freigaben.length > 0) {
        this.setLizenznehmer(this.uiStore.freigaben[0].lizenznehmer);
      }
    }
    this.setDatenGeladen(true);
  }

  /** Gemeinsam genutzte Eventhandller für Eingabefelder */
  @bind @action handleAuftragnameChanged(event: React.FormEvent<FormControl>) {
    this.auftragname = (event.target as HTMLInputElement).value;
  }

  @bind @action handleLizenznehmerChanged(event: React.FormEvent<FormControl>) {
    this.lizenznehmer = (event.target as HTMLInputElement).value;
  }

  @bind @action handlePiChanged(event: React.FormEvent<FormControl>) {
    this.verantwortlicher = (event.target as HTMLInputElement).value;
  }

  @bind @action handleDatumChanged(event: React.FormEvent<FormControl>) {
    this.referenzdatum = (event.target as HTMLInputElement).value;
  }

  @bind @action handleBemerkungChanged(event: React.FormEvent<FormControl>) {
    this.bemerkung = (event.target as HTMLInputElement).value;
  }

  /** Gemeinsam genutzte Setter für Auftragseigenschaften */
  @bind @action setVerantwortlicher(verantwortlicher: string) {
    this.verantwortlicher = verantwortlicher;
  }

  @bind @action setLizenznehmer(lizenznehmer: string) {
    this.lizenznehmer = lizenznehmer;
  }

  validate() {
    let result = (this.auftragname !== '') && (this.referenzdatum !== '') && (this.lizenznehmer);
    // Projektleiter dürfen den Auftrag anderen Personen zuweisen, in diesen Fällen muss zum speichern eine Person gewählt sein
    if (this.uiStore.userProfile && this.uiStore.userProfile.projektleiter) {
      result = result && (this.verantwortlicher !== '');
    }
    return result;
  }


  @bind async handleSubmit(event: React.FormEvent<FormControl>) {
    event.preventDefault();
    let daten: ({}) = {
      'auftragname': this.auftragname,
      'verantwortlicher': this.verantwortlicher,
      'referenzdatum': this.referenzdatum,
      'lizenznehmer': this.lizenznehmer,
      'bemerkung': this.bemerkung,
      'meta': []
    };
    if (this.props.auftrag.kategorie.toLocaleLowerCase() === 'ses') {
      /* tslint:disable:no-string-literal */
      daten['meta'] = this.meta;
      /* tslint:enable:no-string-literal */
    }
    const auftragResponse = await this.apiStore.auftragDetailsAaendern(this.props.auftrag.anr, daten);
    if (auftragResponse.ok) {
      await this.props.onAuftragNeuladen();
      const anr = auftragResponse.json.success as string;
      this.uiStore.navigateTo(`/auftrag/${anr}`);
    }
  }

  render() {
    if (!this.datenGeladen) {
      return <LadeFortschritt/>;
    }

    return (
      <Form horizontal={true} onSubmit={this.handleSubmit}>
        <Panel
          header="Auftragdetails ändern"
          footer={
            <div className="text-right">
              <Button onClick={() => this.uiStore.navigateBack()}>Abbrechen</Button>
              <Button bsStyle="primary" type="submit" disabled={!this.validate()}>Änderungen speichern</Button>
            </div>
          }
        >
          <FormGroup validationState={this.validate() ? undefined : 'error'} controlId="Name">
            <Col componentClass={ControlLabel} sm={3}>Name</Col>
            <Col sm={9}>
              <FormControl type="text" label="Name" value={this.auftragname} onChange={this.handleAuftragnameChanged} />
            </Col>
          </FormGroup>

          <FormGroup validationState={this.lizenznehmer === '' ? 'error' : undefined} controlId="Anlegen für">
            <Col componentClass={ControlLabel} sm={3}>Anlegen für</Col>
            <Col sm={9}>
              <FormControl componentClass="select" placeholder="select" value={this.lizenznehmer} onChange={this.handleLizenznehmerChanged} >
                {this.uiStore.freigaben &&
                  this.uiStore.freigaben.map((freigabe) =>
                    <option key={freigabe.lizenznehmer} value={freigabe.lizenznehmer}>{freigabe.name} ({freigabe.lizenznehmer})</option>
                  )
                }
              </FormControl>
            </Col>
          </FormGroup>

          <FormGroup validationState={this.referenzdatum === '' ? 'error' : undefined} controlId="Referenzdatum">
            <Col componentClass={ControlLabel} sm={3}>Referenzdatum</Col>
            <Col sm={9}>
              <FormControl type="date" label="Referenzdatum" value={this.referenzdatum} onChange={this.handleDatumChanged} />
            </Col>
          </FormGroup>

          {this.uiStore.userProfile && this.uiStore.userProfile.projektleiter &&
            (<FormGroup validationState={this.verantwortlicher === '' ? 'error' : undefined} controlId="Zuweisung">
              <Col componentClass={ControlLabel} sm={3}>Zuweisung</Col>
              <Col sm={9}>
                <FormControl componentClass="select" placeholder="select" value={this.verantwortlicher} onChange={this.handlePiChanged}>
                  <option value="">Bitte zuständige Person wählen...</option>
                  {this.uiStore.personalliste &&
                    this.uiStore.personalliste.map((personal) =>
                      <option key={personal.pi} value={personal.pi}>{personal.vorname} {personal.name} ({personal.pi})</option>
                    )
                  }
                </FormControl>
              </Col>
            </FormGroup>)
          }

          <FormGroup controlId="Bemerkung">
            <Col componentClass={ControlLabel} sm={3}>Bemerkung</Col>
            <Col sm={9}>
              <FormControl componentClass="textarea" type="text" label="Bemerkung" placeholder="Optional" value={this.bemerkung} onChange={this.handleBemerkungChanged}/>
            </Col>
          </FormGroup>

          {this.props.auftrag.kategorie.toLocaleLowerCase() === 'ses' &&
            <div>
              <FormGroup controlId="Fahrzeugkategorie">
                <Col componentClass={ControlLabel} sm={3}>Fahrzeugkategorie</Col>
                <Col sm={9}>
                  <FormControl componentClass="select" placeholder="select" value={this.holeMetadatum(ApiTypes.SES_TYP)} onChange={this.handleSesFzKategorieSelected}>
                    <option value="PKW">PKW</option>
                    <option value="LKW">LKW</option>
                    <option value="KRAD">KRAD</option>
                  </FormControl>
                </Col>
              </FormGroup>

              <FormGroup controlId="Pruefbahn">
                <Col componentClass={ControlLabel} sm={3}>Prüfbahn</Col>
                <Col sm={9}>
                  <FormControl type="text" label="Pruefbahn" placeholder="Optional" value={this.holeMetadatum(ApiTypes.SES_BAHN)} onChange={this.handleSesBahnChanged} />
                </Col>
              </FormGroup>
            </div>
          }

        </Panel>

      </Form>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/auftraege/AuftragDetailsAendern.tsx